const reviews = {
  // Page titles
  title: 'Reviews',
  myReviews: 'My Reviews',
  writeReview: 'Write a Review',

  // Review form
  form: {
    title: 'Write Your Review',
    ratingLabel: 'Your Rating',
    ratingRequired: 'Please select a rating',
    commentLabel: 'Your Comment',
    commentPlaceholder: 'Share your experience...',
    commentOptional: '(optional)',
    photoLabel: 'Add Photos',
    photoOptional: '(optional)',
    anonymousLabel: 'Post anonymously',
    anonymousDescription: 'Your name will not be shown with the review',
    submit: 'Submit Review',
    submitting: 'Submitting...',
    success: 'Your review has been submitted',
    error: 'Failed to submit review',
  },

  // Rating labels
  ratings: {
    1: 'Terrible',
    2: 'Poor',
    3: 'Average',
    4: 'Good',
    5: 'Excellent',
  },

  // Review display
  display: {
    verifiedReview: 'Verified Review',
    helpfulCount: '{{count}} found this helpful',
    helpful: 'Helpful',
    report: 'Report',
    reply: 'Reply',
    edited: 'Edited',
    anonymous: 'Anonymous',
  },

  // Summary
  summary: {
    title: 'Review Summary',
    averageRating: 'Average Rating',
    totalReviews: 'Total Reviews',
    ratingDistribution: 'Rating Distribution',
    stars: 'stars',
    star: 'star',
  },

  // Filters and sorting
  filters: {
    all: 'All',
    withPhotos: 'With Photos',
    verified: 'Verified Only',
    sortBy: 'Sort by',
    newest: 'Newest',
    oldest: 'Oldest',
    highest: 'Highest Rated',
    lowest: 'Lowest Rated',
    mostHelpful: 'Most Helpful',
  },

  // Report
  report: {
    title: 'Report Review',
    reason: 'Reason for Report',
    reasons: {
      spam: 'Spam content',
      inappropriate: 'Inappropriate content',
      fake: 'Fake review',
      offensive: 'Offensive content',
      other: 'Other reason',
    },
    details: 'Additional Details',
    detailsPlaceholder: 'Explain your reason for reporting...',
    submit: 'Submit Report',
    success: 'Report submitted successfully',
    error: 'Failed to submit report',
  },

  // Empty states
  noReviews: 'No reviews',
  noReviewsDescription: 'Be the first to write a review',
  noReviewsYet: 'You have not been reviewed yet',

  // Broker reviews
  broker: {
    reviewBroker: 'Review Broker',
    afterDeal: 'After completing the deal',
    howWasExperience: 'How was your experience with this broker?',
    responseTime: 'Response Time',
    professionalism: 'Professionalism',
    knowledge: 'Knowledge',
    communication: 'Communication',
    overall: 'Overall Rating',
  },

  // Property reviews
  property: {
    reviewProperty: 'Review Property',
    howWasProperty: 'How was this property?',
    accuracy: 'Description Accuracy',
    location: 'Location',
    value: 'Value for Money',
    condition: 'Property Condition',
  },
  // Rating breakdown heading (BrokerRatingSummary); English showed the Arabic default.
  categoryRatings: 'Detailed ratings',
};

export default reviews;
